import { ConnectedUserRegister } from "fleet/controller/connected-user-register";
import {
  ConnectedUserEditPage,
  ConnectedUserNewPage,
} from "fleet/controller/user/connected-detail";
import { ConnectedUserListPage } from "fleet/controller/user/connected-list";
import React from "react";
import { Route } from "react-router-dom";
import { PrivateRoute } from "ui/private-route";
import { VIEW } from "view/views";

function renderUserRoutes() {
  return [
    <PrivateRoute
      exact
      path="/users"
      key="user-list"
      component={ConnectedUserListPage}
    />,
    <PrivateRoute
      exact
      path={`/users/:id/${VIEW.EDIT}`}
      key="user-edit"
      component={ConnectedUserEditPage}
    />,
    <PrivateRoute
      exact
      path={`/users/${VIEW.CREATE}`}
      key="user-new"
      component={ConnectedUserNewPage}
    />,
    <Route
      exact
      path="/register/:id"
      key="user-register"
      component={ConnectedUserRegister}
    />,
  ];
}

export { renderUserRoutes };
